import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/images/svg/giphy-attribution.svg?data'


const _hoisted_1 = /*#__PURE__*/_createElementVNode("p", { class: "quiz-basic-stage-gifs__title" }, "Select gifs", -1)
const _hoisted_2 = { class: "grid column-gap-10" }
const _hoisted_3 = { class: "quiz-basic-stage-gifs-stack__header" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", null, "Search and select gif", -1)
const _hoisted_5 = { class: "quiz-basic-stage-gifs-stack__gif-wrapper" }
const _hoisted_6 = {
  key: 0,
  class: "quiz-basic-stage-gifs-stack__gifs"
}
const _hoisted_7 = ["src", "onClick"]
const _hoisted_8 = {
  key: 1,
  class: "quiz-basic-stage-gifs-stack__no-results"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("p", { class: "p-large" }, "No results", -1)
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "quiz-basic-stage-gifs-stack__attribution" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_0 })
], -1)
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" Continue ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_QuizInteractionButton = _resolveComponent("QuizInteractionButton")!
  const _component_AppIcon = _resolveComponent("AppIcon")!
  const _component_AppInput = _resolveComponent("AppInput")!
  const _component_AppButton = _resolveComponent("AppButton")!
  const _component_QuizCard = _resolveComponent("QuizCard")!

  return (_openBlock(), _createBlock(_component_QuizCard, {
    title: "You in 3 gifs",
    description: "Choose 3 gifs that describe you well. By the way it’s pronounced “gif”, not “jif”.",
    class: "quiz-basic-stage-gifs",
    "is-vertically-aligned": true,
    "onQuizNavigation:back": _ctx.navigatePrev,
    "onQuizNavigation:close": _cache[1] || (_cache[1] = ($event: any) => (_ctx.QuizService.close())),
    prev: !_ctx.QuizService.editing.value
  }, {
    actions: _withCtx(() => [
      (!_ctx.displayGifSlider)
        ? (_openBlock(), _createBlock(_component_AppButton, {
            key: 0,
            onClick: _ctx.navigateNext,
            loading: _ctx.QuizService.isSaving()
          }, {
            default: _withCtx(() => [
              _hoisted_12
            ]),
            _: 1
          }, 8, ["onClick", "loading"]))
        : _createCommentVNode("", true)
    ]),
    default: _withCtx(() => [
      _hoisted_1,
      _createElementVNode("section", _hoisted_2, [
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(3, (index) => {
          return _createElementVNode("div", {
            key: index,
            class: "col-4"
          }, [
            _createVNode(_component_QuizInteractionButton, {
              icon: "plus",
              "onUserAction:click": ($event: any) => (_ctx.selectGif(index)),
              "onUserAction:delete": ($event: any) => (_ctx.selectedGifs[index - 1] = ''),
              image: _ctx.selectedGifs[index - 1]
            }, null, 8, ["onUserAction:click", "onUserAction:delete", "image"])
          ])
        }), 64))
      ]),
      _createElementVNode("section", {
        class: _normalizeClass(["quiz-basic-stage-gifs-stack", { 'quiz-basic-stage-gifs-stack--active': _ctx.displayGifSlider }])
      }, [
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _createVNode(_component_AppIcon, {
            name: "close",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.displayGifSlider = false))
          })
        ]),
        _createVNode(_component_AppInput, {
          modelValue: _ctx.searchTerm,
          "onUpdate:modelValue": _ctx.performSearch,
          type: "text",
          id: "quiz-basic-stage-gifs-search",
          placeholder: "Search GIPHY",
          icon: "search",
          class: "quiz-basic-stage-gifs-stack__input",
          maxlength: "30",
          isLoading: _ctx.isLoading
        }, null, 8, ["modelValue", "onUpdate:modelValue", "isLoading"]),
        _createElementVNode("div", _hoisted_5, [
          (_ctx.fetchedGifs.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.fetchedGifs, (fetchedGif, index) => {
                  return (_openBlock(), _createElementBlock("img", {
                    key: index,
                    src: fetchedGif.gif,
                    onClick: ($event: any) => (_ctx.setSelectedGif(fetchedGif.gif))
                  }, null, 8, _hoisted_7))
                }), 128))
              ]))
            : _createCommentVNode("", true),
          (_ctx.displayGifSlider && !_ctx.fetchedGifs.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, _hoisted_10))
            : _createCommentVNode("", true)
        ]),
        _hoisted_11
      ], 2)
    ]),
    _: 1
  }, 8, ["onQuizNavigation:back", "prev"]))
}